module.exports = __webpack_public_path__ + "static/media/Car-step-icon.340dbe28.svg";